export default __webpack_public_path__ + "static/media/Questions.a2fa3349.svg";